import isPresent from './is_present';

export default function depixify(value) {
  if (isPresent(value)) {
   value = String(value).includes('px') ? value.replace('px', '') : value;
    return parseInt(value, 10);
  }
}
